<template>
    <div class="wrap">
        <input :type="formtypeprops" hidden>

        <div class="form__title-wrap">
            <h3 class="form__title"
                v-for="itemChildren in formsItem"
                v-if="itemChildren.type === 'title'">{{itemChildren.title}}</h3>
            <div class="back-link" @click="backContactInformationShow">
                <div class="icon icon-arrow-longer"></div>
                <div class="text">Contact information</div>
            </div>
        </div>

        <fieldsStringerPallet :array="$store.state.stringerPallet"
                              @returnStatusToParent="formStatus =>childIsValid=formStatus"
                              :items="formsItem"></fieldsStringerPallet>

        <div class="button-wrap">
            <button type="button" class="btn" @click="submit" :class="{'disable': $store.state.submitstatus === 'PENDING'}">Submit request</button>
        </div>

        <div class="info-text" v-if="submitStatus === 'ERROR'">
            <div class="error-wrap" v-if="submitStatus === 'ERROR'">
                <div class="icon-cross close" @click="submitStatus = null"></div>
                Some required fields are missing. Please fix them.
            </div>
        </div>

        <div class="info-text" v-if="submitStatus === 'OK'">
            <div class="success" v-if="submitStatus === 'OK'">
                <div class="icon-cross close" @click="submitStatus = null"></div>
                Thanks for your submission!
            </div>
        </div>

        <div class="info-text" v-if="submitStatus === 'PENDING'">
            <div class="typo__p" v-if="submitStatus === 'PENDING'">Sending...</div>
        </div>

        <vue-recaptcha :sitekey="recapthcakeyprops"
                       data-badge="inline"
                       ref="recaptcha"
                       size="invisible"
                       @verify="onVerify"></vue-recaptcha>
    </div>
</template>

<script>
    import fieldsStringerPallet from "./fieldsStringerPallet.vue";
    import Vue from 'vue'
    import Vuex from 'vuex';
    import Vuelidate from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    import VueRecaptcha from 'vue-recaptcha';
    import VueScrollTo from 'vue-scrollto'
    import VueMask from 'v-mask'
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css";
    Vue.component("v-select", vSelect);

    Vue.use(Vuex);
    Vue.use(VueMask);
    Vue.use(Vuelidate);
    Vue.use(VueScrollTo);

    export default {
        name: 'StringerPallet',
        components: {
            'vue-recaptcha': VueRecaptcha,
            fieldsStringerPallet,
        },
        props: [
            'formtypeprops',
            'recapthcakeyprops',
            'actions',
            'formsItem',
            'form_id'
        ],
        data() {
            return {
                captcha: '',
                captchaActive: false,
                childIsValid: false,
                submitStatus: null,
            }
        },
        validations() {

        },
        methods: {
            onFileChange(el) {
                // eslint-disable-next-line no-unused-vars
                const files = el.target.files || el.dataTransfer.files
                // eslint-disable-next-line prefer-destructuring
                this.file = document.getElementById('upload').files[0].name
            },
            submit() {
                this.$eventPool.$emit("touchChildForm")

                this.$nextTick(() => {
                    this.submitStatus = 'PENDING';

                    if (this.childIsValid) {
                        this.$refs.recaptcha.execute();
                    } else {
                        this.submitStatus = 'ERROR';
                        setTimeout(() => {
                            VueScrollTo.scrollTo('.error', 300);
                        }, 200);
                    }
                })
            },
            onVerify: function (response) {
                let formData = new FormData();
                formData.append('g-recaptcha-response', response);
                formData.append('form_type', 'stringer-pallet');
                formData.append('form_id', this.form_id);

                const currentForm = this.$store.state.currentForm
                Object.keys(currentForm).forEach((item) => {
                    if (typeof currentForm[item] === 'object') {
                        formData.append(item, JSON.stringify(currentForm[item]))
                    } else {
                        formData.append(item, currentForm[item])
                    }
                })

                axios.post(this.actions, formData)
                    .then(response => {
                        console.log('message', response);

                        if (response.data.result === 'ok') {
                            this.submitStatus = 'OK';

                            formData = new FormData();
                            this.childHasError = true;
                            this.$store.state.currentForm = {};
                            // this.$refs.vform.reset();
                            this.$eventPool.$emit("resetChildForm");
                        }

                        if (response.data.result === 'error') {
                            this.submitStatus = 'ERROR';
                        }

                        this.$refs.recaptcha.reset();
                    })
                    .catch(error => {
                        console.log(error)
                        this.$refs.recaptcha.reset();
                    });
            },
            status(validation) {
                return {
                    error: validation.$error,
                    dirty: validation.$dirty
                }
            },
            backContactInformationShow() {
                this.$store.state.blockPalletActive = false
                this.$store.state.stringerPalletActive = false
                this.$store.state.contactInformationActive = true
            },
        },
        mounted() {
            VueScrollTo.scrollTo('.GetAQuoteForm', 300);
        }
    }
</script>
